export const reactivateTodayPerks = [
  {
    title: 'Member’s Only Sales',
    description: 'Find amazing brands and products at incredible discounts.',
    icon: 'fa-shopping-bag',
  },
  {
    title: 'Customization',
    description:
      'Every season members get a chance to fully customize their seasonal box.',
    icon: 'fa-hand-holding-box',
  },
  {
    title: 'FabFitFun TV',
    description:
      'Stream our digital library of workouts, cooking demos, DIYs, and more.',
    icon: 'fa-tv',
  },
  {
    title: 'Community Forum',
    description:
      'Chat with other members in the Community, available through our website and app.',
    icon: 'fa-comments',
  },
];
